export default __webpack_public_path__ + "static/media/maker.b6f34b79.svg";